import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  if (amount === undefined || amount === null || isNaN(amount)) {
    return '₱0.00';
  }
  return new Intl.NumberFormat('en-PH', {
    style: 'currency',
    currency: 'PHP',
  }).format(amount);
}

export function formatDate(date) {
  if (!date) return '';
  const tz = localStorage.getItem('u_dorm_timezone');
  const opts = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  if (tz) opts.timeZone = tz;
  return new Date(date).toLocaleDateString('en-PH', opts);
}

export function formatDateTime(date) {
  if (!date) return '';
  const tz = localStorage.getItem('u_dorm_timezone');
  const opts = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };
  if (tz) opts.timeZone = tz;
  return new Date(date).toLocaleString('en-PH', opts);
}

export function getStatusColor(status) {
  const colors = {
    active: 'bg-emerald-100 text-emerald-800',
    pending: 'bg-amber-100 text-amber-800',
    verified: 'bg-emerald-100 text-emerald-800',
    expired: 'bg-gray-100 text-gray-800',
    terminated: 'bg-gray-100 text-gray-800',
    rejected: 'bg-red-100 text-red-800',
    vacant: 'bg-blue-100 text-blue-800',
    occupied: 'bg-emerald-100 text-emerald-800',
    partially_occupied: 'bg-amber-100 text-amber-800',
    maintenance: 'bg-amber-100 text-amber-800',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}

export function getPaymentMethodColor(method) {
  const colors = {
    gcash: 'bg-blue-100 text-blue-800',
    maya: 'bg-green-100 text-green-800',
    diskartech: 'bg-orange-100 text-orange-800',
    cash: 'bg-gray-100 text-gray-800',
    bank: 'bg-purple-100 text-purple-800',
  };
  return colors[method?.toLowerCase()] || 'bg-gray-100 text-gray-800';
}

export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function getCurrentMonth() {
  // Use LOCAL year/month (not toISOString, which is UTC and shifts the month
  // backwards for positive-offset timezones like PH UTC+8 near month boundaries).
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function generateMonthOptions() {
  const months = [];
  const now = new Date();
  for (let i = -3; i <= 3; i++) {
    const date = new Date(now.getFullYear(), now.getMonth() + i, 1);
    months.push({
      // Local year-month so the stored value matches the displayed label.
      value: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`,
      label: date.toLocaleDateString('en-PH', { year: 'numeric', month: 'long' }),
    });
  }
  return months;
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
